function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  handleColor: PropTypes.string,
  height: PropTypes.number.isRequired,
  onUpdateSelection: PropTypes.func.isRequired,
  selection: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectionColor: PropTypes.string,
  outsideColor: PropTypes.string,
  width: PropTypes.number.isRequired,
  handleWidth: PropTypes.number,
  zoomable: PropTypes.bool
};
var defaultProps = {
  handleColor: '#333',
  selectionColor: 'none',
  outsideColor: '#777',
  zoomable: true,
  handleWidth: 2
};

var Brush = function (_React$Component) {
  _inherits(Brush, _React$Component);

  function Brush() {
    var _temp, _this, _ret;

    _classCallCheck(this, Brush);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dragStartOverlay: null,
      dragStartSelection: null,
      isDraggingHandleEast: false,
      isDraggingHandleWest: false,
      isDraggingOverlay: false,
      isDraggingSelection: false
    }, _this.onMouseDownOverlay = function (e) {
      if (!_this.props.zoomable) {
        return;
      }

      _this.setState({
        isDraggingOverlay: true,
        dragStartOverlay: e.nativeEvent.offsetX
      });
    }, _this.onMouseDownHandleEast = function () {
      if (!_this.props.zoomable) {
        return;
      }

      _this.setState({
        isDraggingHandleEast: true
      });
    }, _this.onMouseDownHandleWest = function () {
      if (!_this.props.zoomable) {
        return;
      }

      _this.setState({
        isDraggingHandleWest: true
      });
    }, _this.onMouseDownSelection = function (e) {
      if (!_this.props.zoomable) {
        return;
      }

      _this.setState({
        isDraggingSelection: true,
        dragStartSelection: e.nativeEvent.offsetX
      });
    }, _this.onMouseUpSelection = function () {
      if (!_this.props.zoomable) {
        return;
      }

      _this.setState({
        isDraggingSelection: false
      });
    }, _this.onMouseUp = function () {
      if (!_this.props.zoomable) {
        return;
      }

      _this.setState({
        isDraggingHandleEast: false,
        isDraggingHandleWest: false,
        isDraggingOverlay: false,
        isDraggingSelection: false,
        dragStartOverlay: null,
        dragStartSelection: null
      });
    }, _this.onMouseMove = function (e) {
      if (!_this.props.zoomable) {
        return;
      }

      if (_this.state.isDraggingHandleEast) {
        var position = e.nativeEvent.offsetX;
        var selection = _this.props.selection;

        if (position < selection[0]) {
          _this.setState({
            isDraggingHandleEast: false,
            isDraggingHandleWest: true
          });

          return;
        }

        var newSelection = [selection[0], position];

        _this.props.onUpdateSelection(newSelection);
      } else if (_this.state.isDraggingHandleWest) {
        var _position = e.nativeEvent.offsetX;
        var _selection = _this.props.selection;

        if (_position > _selection[1]) {
          _this.setState({
            isDraggingHandleWest: false,
            isDraggingHandleEast: true
          });

          return;
        }

        var _newSelection = [_position, _selection[1]];

        _this.onUpdateSelection(_newSelection);
      } else if (_this.state.isDraggingSelection) {
        var _this$props = _this.props,
            _selection2 = _this$props.selection,
            width = _this$props.width;
        var dragStartSelection = _this.state.dragStartSelection;
        var _position2 = e.nativeEvent.offsetX;
        var dx = _position2 - dragStartSelection;

        var _newSelection2 = _selection2.map(function (d) {
          return d + dx;
        });

        if (_newSelection2[0] >= 0 && _newSelection2[1] <= width) {
          _this.setState({
            dragStartSelection: _position2
          });

          _this.props.onUpdateSelection(_newSelection2);
        }
      } else if (_this.state.isDraggingOverlay) {
        var dragStartOverlay = _this.state.dragStartOverlay;

        var _newSelection3 = [dragStartOverlay, e.nativeEvent.offsetX].sort(function (a, b) {
          return a - b;
        });

        _this.props.onUpdateSelection(_newSelection3);
      }
    }, _this.onUpdateSelection = function (selection) {
      _this.props.onUpdateSelection(selection);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Brush.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('mouseup', this.onMouseUp);
  };

  Brush.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('mouseup', this.onMouseUp);
  };

  Brush.prototype.render = function render() {
    var _props = this.props,
        width = _props.width,
        height = _props.height,
        selection = _props.selection,
        selectionColor = _props.selectionColor,
        outsideColor = _props.outsideColor,
        handleColor = _props.handleColor,
        zoomable = _props.zoomable,
        handleWidth = _props.handleWidth;
    var selectionWidth = selection[1] - selection[0];
    var disabledCursor = zoomable ? null : 'inherit';
    var handleTargetWidth = 10;
    return React.createElement('g', {
      fill: 'none',
      stoke: '#777',
      onMouseMove: this.onMouseMove
    }, React.createElement('rect', {
      className: 'before-selection',
      fill: outsideColor,
      fillOpacity: 0.3,
      stroke: '#fff',
      shapeRendering: 'crispEdges',
      width: Math.max(0, selection[0]),
      height: height,
      x: 0,
      y: 0
    }), React.createElement('rect', {
      className: 'after-selection',
      fill: outsideColor,
      fillOpacity: 0.3,
      stroke: '#fff',
      shapeRendering: 'crispEdges',
      width: Math.max(0, width - selection[1]),
      height: height,
      x: selection[1],
      y: 0
    }), React.createElement('rect', {
      className: 'overlay',
      pointerEvents: 'all',
      cursor: disabledCursor || 'crosshair',
      x: 0,
      y: 0,
      fill: 'none',
      width: width,
      height: height,
      onMouseDown: this.onMouseDownOverlay
    }), React.createElement('rect', {
      className: 'selection',
      cursor: disabledCursor || 'move',
      fill: selectionColor,
      fillOpacity: 0.3,
      pointerEvents: 'all',
      shapeRendering: 'crispEdges',
      width: selectionWidth,
      height: height,
      x: selection[0],
      y: 0,
      onMouseDown: this.onMouseDownSelection
    }), React.createElement('path', {
      className: 'handle handle--west',
      stroke: handleColor,
      strokeWidth: handleWidth,
      d: 'M ' + selection[0] + ' 0 V ' + height
    }), React.createElement('rect', {
      className: 'handle-target handle-target--west',
      cursor: disabledCursor || 'ew-resize',
      x: selection[0] - handleTargetWidth / 2,
      y: 0,
      width: handleTargetWidth,
      height: height,
      fill: 'none',
      pointerEvents: 'all',
      onMouseDown: this.onMouseDownHandleWest
    }), React.createElement('path', {
      className: 'handle handle--east',
      stroke: handleColor,
      strokeWidth: handleWidth,
      d: 'M ' + selection[1] + ' 0 V ' + height
    }), React.createElement('rect', {
      className: 'handle-target handle-target--east',
      cursor: disabledCursor || 'ew-resize',
      x: selection[1] - handleTargetWidth / 2,
      y: 0,
      width: handleTargetWidth,
      height: height,
      fill: 'none',
      pointerEvents: 'all',
      onMouseDown: this.onMouseDownHandleEast
    }));
  };

  return Brush;
}(React.Component);

Brush.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Brush.defaultProps = defaultProps;
export default Brush;